import React from 'react';
import _ from 'lodash';
import {EmailShareIcon, FbShareIcon, TwitterShareIcon} from '../../shared/Svgs';
import {getGATags} from '../../shared/utilities/GAHelpers';

/**
 * Share icon info
 * @param {string} canonical canonical url
 * @param {string} title     share title
 * @return {Array} array of share icon info
 */
export function ShareIcons(canonical, title) {
  const encodedCanonical = encodeURIComponent(canonical);
  const encodedTitle = encodeURIComponent(title);

  return [
    {
      label: 'facebook',
      shareUrl: `https://www.facebook.com/share.php?u=${encodedCanonical}&title=${encodedTitle}`,
      svg: <FbShareIcon />,
    },
    {
      label: 'twitter',
      shareUrl: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedCanonical}`,
      svg: <TwitterShareIcon />,
    },
    {
      label: 'email',
      shareUrl: `mailto:?body=This obituary I found on Legacy.com may interest you: ${encodedCanonical}`,
      svg: <EmailShareIcon />,
    },
  ];
}

/**
 * Handle clicking of share icons
 * @param  {Object} e The Event Object
 * @param  {String} url The share url
 * @param  {String} type The share type
 * @param  {Boolean} track Indication of whether or not to fire a GA event
 * @return {Undefined} Returns nothing
 */
export function HandleShareClick(e, url, type, track = true) {
  e.preventDefault();

  if (type === 'email') {
    window.location.replace(url, '_blank');
  } else {
    window.open(
      url,
      `${_.upperFirst(type.replace('_', ' '))} Share`,
      'status = 1, height = 500, width = 500, resizable = 0'
    );
  }

  if (track) {
    getGATags({
      eventCategory: 'Person_Page_Social_Buttons',
      eventAction: 'click',
      eventLabel: type,
    });
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/shareHelpers.js